import { useState, useEffect } from 'react'

/**
 * Counts down to the end of the current day (local midnight), so the offer
 * genuinely reads as "solo por hoy". When it reaches 00:00:00 it rolls over
 * to the next midnight automatically.
 */
function secondsUntilMidnight() {
  const now = new Date()
  const midnight = new Date(now)
  midnight.setHours(24, 0, 0, 0)
  return Math.max(0, Math.floor((midnight.getTime() - now.getTime()) / 1000))
}

export function useCountdown() {
  const [timeLeft, setTimeLeft] = useState(secondsUntilMidnight)
  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(secondsUntilMidnight())
    }, 1000)
    return () => clearInterval(interval)
  }, [])
  const hours = Math.floor(timeLeft / 3600)
  const minutes = Math.floor((timeLeft % 3600) / 60)
  const seconds = timeLeft % 60
  return {
    hours: hours.toString().padStart(2, '0'),
    minutes: minutes.toString().padStart(2, '0'),
    seconds: seconds.toString().padStart(2, '0'),
  }
}
